export const ModalType = {
  PREFERENCES: 'PREFERENCES',
  PWD_CHANGE: 'PWD_CHANGE',
  DEFAULT: 'default'
};
